import { FormlyFieldConfig } from "@ngx-formly/core";


const editMode = false;

export const OccupazioneUrgenzaStep: FormlyFieldConfig[] =
    [
      {
        "wrappers":['alert-note'],
        "props":{
          "description":'Per motivi di reale urgenza operativa (al fine di scongiurare una situazione di pericolo grave ed imminente), si dovrà intervenire in data odierna in:'
        }
      },
      {
        "fieldGroupClassName":'grid md:grid-cols-2 sm:grid-cols-1 gap-4',
        "fieldGroup": [
          {
            "className":'sm:col-span-1 md:col-span-1',
            "key":'jd.occupazione_tipo',
            "type":editMode ? 'select' : 'select-read',
            "props":{
              "label":'TIPO DI RICHIESTA URGENTE',
              "options":[
                {"value":'cantiere', "label":'CANTIERE: AUTORIZZAZIONE OCCUPAZIONE SUOLO PER CANTIERE'},
                {"value":'scavo', "label":'SCAVO: AUTORIZZAZIONE OCCUPAZIONE SUOLO PER SCAVO'}
              ],
              "required":true
            }
          },
          {
            "className":'sm:col-span-1 md:col-span-1',
            "key": 'jd.via',
            "type": editMode ? 'mat-autocomplete' : 'mat-autocomplete-read',
            "props": {
              "label": "VIA",
              "required":true
            },
            "validation": {
              "show": true,
            },
            validators:{
              validation:['AutocompleteMatch'],
          }     ,
            hooks: {
              onInit: (field) => field.props.filter = (term: string) => field.options.formState.cmp._ubicazioneService.getViaByTerm(term)
            },
          },
          {
            "className":'sm:col-span-1 md:col-span-1',
            "key":'jd.occupazione_lunghezza',
            "type":editMode ? 'input' : 'input-read',
            "props":{
              "label":'LUNGHEZZA OCCUPAZIONE IN METRI',
              "type":'number',
              "required":true
            }
          },
          {
            "className":'sm:col-span-1 md:col-span-1',
            "key": 'jd.occupazione_larghezza',
            "type": editMode ? 'input' : 'input-read',
            "props": {
              "label":'LARGHEZZA OCCUPAZIONE IN METRI',
              "required":true,
              "type":'number'
            },
          },
          {
            "className":'sm:col-span-1 md:col-span-1',
            "key":'jd.occupazione_con',
            "type":editMode ? 'input' : 'input-read',
            "props":{
              "label":'CON (PIATTAFORMA/PONTEGGIO/STECCATO/ECC.)',
              "required":true
            }
          },
          {
            "className":'sm:col-span-1 md:col-span-1',
            "key": 'jd.occupazione_su',
            "type": editMode ? 'input' : 'input-read',
            "props": {
              "label":'SU (MARCIAPIEDE/PARCHEGGIO/CARREGGIATA/ECC.)',
              "required":true,
            },
          },
          {
            "className":'sm:col-span-1 md:col-span-2',
            "key": 'jd.motivo_urgenza',
            "type": editMode ? 'textarea' : 'input-read',
            "props": {
              "label": 'DESCRIZIONE ATTIVITÀ',
              "required": true,
              "autosize": true,
              "autosizeMaxRows": 8,
              "autosizeMinRows": 2,
            },
            validation: {
              show: true
            }
          },
        ]
      },
      {
        "wrappers":['alert-note'],
        "props":{
          "description":'L’occupazione d’urgenza può essere effettuata anche prima dell’ottenimento del formale atto di concessione o autorizzazione, che verrà rilasciato successivamente a titolo di regolarizzazione - sussistendone i requisiti - per far fronte a gravi situazioni d’urgenza ed emergenza o quando si tratti di provvedere a lavori per tutela della pubblica incolumità.'
        }
      },
      {
        "template": `<div class="flex justify-center text-lg font-semibold">IL SOTTOSCRITTO DICHIARA:</div>`
      },
      {
        "template": `<ul class="list-disc pl-5 space-y-2 text-gray-700">
        <li class="flex items-start">
          <span class="ml-2">Di garantire gli accessi ai fondi e le visuali alle vetrine;</span>
        </li>
        <li class="flex items-start">
          <span class="ml-2">Di osservare tutte le vigenti disposizioni in materia di suolo pubblico, polizia urbana e sanità;</span>
        </li>
        <li class="flex items-start">
          <span class="ml-2">Di realizzare il cantiere in conformità alle previsioni degli artt. 21-27 Nuovo Codice della Strada - D.lgs. 285/1992 e degli artt. 30 e ss. del relativo Regolamento di esecuzione;</span>
        </li>
        <li class="flex items-start">
          <span class="ml-2">Di non occultare lampade semaforiche e cartelli stradali;</span>
        </li>
        <li class="flex items-start">
          <span class="ml-2">Di rimuovere immediatamente l'occupazione in caso di semplice richiesta del Comune;</span>
        </li>
        <li class="flex items-start">
          <span class="ml-2">Di porre in essere tutti i necessari accorgimenti atti ad evitare dispersione di polveri o schegge;</span>
        </li>
        <li class="flex items-start">
          <span class="ml-2">Di essere a conoscenza delle modalità di ripristino stabilite dal regolamento comunale di manomissione e rottura del suolo pubblico con l’impegno ad uniformarsi ad esse e alle eventuali particolari prescrizioni rilasciate dal Servizio Mobilità;</span>
        </li>
        <li class="flex items-start">
          <span class="ml-2">Di essere a conoscenza che nelle aree Pedonali ed in ZTL non possono essere utilizzati veicoli di massa a pieno carico superiore a 3.5 tonnellate;</span>
        </li>
        <li class="flex items-start">
          <span class="ml-2">Il titolare dell'autorizzazione si assume la responsabilità di riparare eventuali danni derivanti dalle opere e dalle occupazioni in oggetto;</span>
        </li>
      </ul>
      `
      },
      {
        "wrappers":['alert-note'],
        "props":{
          "description":'L’inosservanza di una qualsiasi delle suddette condizioni, potrà essere causa del diniego o della decadenza dell’autorizzazione rilasciata.'
        }
      },
      {
        "key": 'jd.accettazione_prescrizioni-1',
        "type": editMode ? 'checkbox' : 'checkbox-read',
        "defaultValue":false,
        "props": {
          "label": "IL SOTTOSCRITTO HA PRESO VISIONE E ACCETTA LE SOPRA ELENCATE PRESCRIZIONI.",
          "indeterminate": false,
          "color": 'primary',
        }
      },
      {
        "key": 'jd.urgenza_opt-1-1',
        "type": editMode ? 'checkbox' : 'checkbox-read',
        "defaultValue":false,
        "props": {
          "label": "IL SOTTOSCRITTO SI IMPEGNA A PRESENTARE, ENTRO LE PROSSIME 48 ORE LAVORATIVE, REGOLARE ISTANZA DI OCCUPAZIONE DEL SUOLO PUBBLICO CON TUTTI GLI ULTERIORI ADEMPIMENTI RICHIESTI PER LA NORMALE PROCEDURA.",
          "indeterminate": false,
          "color": 'primary',
        }
      },
    ]

